import { Share, ShareOptions } from "@capacitor/share";

import { Capacitor } from "@capacitor/core";
import { AppSettings } from "@core/types";
import i18n from "../i18n";

interface ShareAppProps extends Partial<ShareOptions> {
  appSettings?: AppSettings | undefined;
  shareTextMessageProp?: string;
}

export const generateShareMessage = (appSettings?: AppSettings, includeText?: boolean): string => {
  const text = appSettings?.sharedData?.text || "";
  const iosUrl = appSettings?.sharedData?.iosUrl || "";
  const androidUrl = appSettings?.sharedData?.androidUrl || "";

  return `${includeText ? text + "\n" : ""}IOS: ${iosUrl}\nAndroid: ${androidUrl}`;
};

export const shareApp = async ({
  dialogTitle,
  files,
  title,
  appSettings,
  shareTextMessageProp,
}: ShareAppProps): Promise<string> => {
  const shareTextMessage = shareTextMessageProp || generateShareMessage(appSettings, true);

  const shareData: ShareOptions = {
    title: title || appSettings?.sharedData?.title,
    text: shareTextMessage,
    dialogTitle,
    files,
  };

  const canShare = await Share.canShare();
  const canShareValue = canShare.value;

  if (!canShareValue) return "";

  await Share.share(shareData);

  return generateShareMessage(appSettings, true);
};

export const showSharingOptions = async (
  phoneNumber: string,
  config: any,
  ts: any,
  presentAlert: (options: any) => Promise<void>,
) => {
  const shareText = generateShareMessage(config, true);
  const smsText = generateShareMessage(config, false);
  const phoneOnlyNumbers = phoneNumber.replace(/\D/g, "");
  const phoneNumberWithPlus = `+${phoneOnlyNumbers}`;

  const alertOptions = {
    header: i18n.t("Share"),
    message: i18n.t("chooseShareMethod"),
    cssClass: "sharing-alert",
    buttons: [
      {
        text: "WhatsApp",
        cssClass: "sharing-button whatsapp-button",
        handler: () => {
          const whatsappUrl = `https://wa.me/${phoneNumberWithPlus}?text=${encodeURIComponent(shareText)}`;
          window.open(whatsappUrl, "_blank");
        },
      },
      {
        text: "Telegram",
        cssClass: "sharing-button telegram-button",
        handler: () => {
          const webTelegramUrl = `https://t.me/${phoneNumberWithPlus}?text=${encodeURIComponent(shareText)}`;
          window.open(webTelegramUrl, "_blank");
        },
      },
      {
        text: "SMS",
        cssClass: "sharing-button sms-button",
        handler: () => {
          let smsUrl;

          if (Capacitor.getPlatform() === "ios") {
            smsUrl = `sms:${phoneNumberWithPlus}&body=${encodeURIComponent(smsText)}`;
          } else {
            smsUrl = `sms:${phoneNumberWithPlus}?body=${encodeURIComponent(smsText)}`;
          }

          console.log("sdfdsfdsfsdfsdfsd", { smsUrl });

          window.open(smsUrl, "_blank");
        },
      },
      {
        text: i18n.t("Cancel"),
        cssClass: "sharing-button cancel-button",
        role: "cancel",
      },
    ],
  };

  await presentAlert(alertOptions);
};
